import { Drawer, DrawerProps, Modal, ModalProps } from "antd";
import { isMobile } from "../../utils";

export interface DrawerModalProps
  extends Omit<ModalProps, "visible" | "onCancel">,
    Omit<DrawerProps, "visible" | "onClose"> {
  visible?: boolean;
  onCancel?: (e: any) => void;
}

export const DrawerModal: React.FC<DrawerModalProps> = ({
  height,
  visible,
  onCancel,
  children,
  className,
  ...props
}) => {
  return isMobile() ? (
    <Drawer
      destroyOnClose
      visible={visible}
      placement="bottom"
      onClose={onCancel}
      className={`modal-drawer ${className} ${!props.title ? "untitled" : ""}`}
      height={height ?? "calc(100% - 64px)"}
      {...props}
    >
      {children}
    </Drawer>
  ) : (
    <Modal
      destroyOnClose
      footer={null}
      visible={visible}
      onCancel={onCancel}
      className={`modal-drawer ${className}`}
      {...props}
    >
      {children}
    </Modal>
  );
};
